/* eslint-disable */
/* eslint-disable no-unused-vars */
import React, {useContext } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import _ from 'lodash';

import ViewWalletLogs from './ViewWalletLogs';
import WalletTxn from './WalletTxn';

import * as action from '../actions';
import * as c from '../constants';

const ActionItemButtonGroup = ({
  // findingLogs,
  walletTransId,
  walletTransDetails,
  viewWalletLogs,
  updateWalletRollback,
  viewWalletLogsForTxn,
  findWallet,
  setFormData,
  walletDateAt,
  formData,
  mobileNumber,
  transId,
  onClear,
}) => {
  const setModal = useContext(ModalContext);

  // View Logs
  const handleViewWalletLogs = () => {
    const args = {
      wallet_transaction_id: walletTransId,
    };

    viewWalletLogs(args, (res) => {
      const logs = _.get(res, 'res.data');
      setModal({
        isOpen: true,
        content: <ViewWalletLogs logs={logs} />,
        title: 'View Wallet Transaction Logs',
        modalSize: 'modal-xl',
      });
    });
  };

  // handle Rollback
  const handleUpdateRollback = () => {
    const args = {
      cash_in_transaction_id: _.get(walletTransDetails, 'detail_id'),
    };

    updateWalletRollback(args, () => findWallet(mobileNumber));
  };

  // const handleClear = e => {
  //   e.preventDefault();
  //   setFormData({
  //     refno: '',
  //   });
  //   setPaymentInfo('');
  // };

  // handle Change Txn ID
  const handeUpdateTxnID = () => {
    // check logs for txnId
    const cashInTransactionId = _.toString(
      _.get(walletTransDetails, 'detail_id')
    );
    const txnId = _.get(walletTransDetails.detail, 'txnid');
    const args = {
      cash_in_transaction_id: cashInTransactionId,
      txnid: txnId,
    };

    // todo: refactor later, map logListData to an array..
    viewWalletLogs({ wallet_transaction_id: walletTransId }, (res) => {
      const logListData = _.get(res, 'res.data')
      setModal({
        isOpen: true,
        content: (
          <WalletTxn
            cashInTransactionId={cashInTransactionId}
            logs={logListData}
            setFormData={setFormData}
            formData={formData}
            onClear={onClear}
          />
        ),
        title: 'Change TXNID',
        modalSize: 'modal-md',
      });
    });
  };

  return (
    <div className="d-flex justify-content-center align-items-center mt-auto">
      {_.get(walletTransDetails, 'detail_type') === 'CASH_IN' ? (
        <>
          <button
            onClick={handleViewWalletLogs}
            type="button"
            className="btn btn-outline-primary w-100"
            style={{ height: '50px' }}
          >
            {/* {findingLogs ? (
              <>
                <i className="fa fa-spin fa-spinner" /> &nbsp;
              </>
            ) : ( */}
            <b>Logs</b>
            {/* )} */}
          </button>
          {/* <button
            onClick={handleUpdateRollback}
            type="button"
            className="btn btn-outline-primary ml-2 w-100"
          >
            {findingLogs ? (
              <>
                <i className="fa fa-spin fa-spinner" /> &nbsp;
              </>
            ) : (
            <b className="">Rollback</b>
            )}
          </button> */}
          <button
            onClick={handeUpdateTxnID}
            type="button"
            className="btn btn-outline-primary ml-2 w-100"
            style={{ height: '50px' }}
          >
            {/* {findingLogs ? (
              <>
                <i className="fa fa-spin fa-spinner" /> &nbsp;
              </>
            ) : ( */}
            <b>Update TXN ID</b>
            {/* )} */}
          </button>
        </>
      ) : null}
    </div>
  );
};

ActionItemButtonGroup.propTypes = {
  findWallet: PropTypes.instanceOf(Function).isRequired,
  // walletTransaction: PropTypes.instanceOf(Object).isRequired,
  walletTransId: PropTypes.string.isRequired,
  walletTransDetails: PropTypes.instanceOf(Object).isRequired,
  viewWalletLogs: PropTypes.instanceOf(Function).isRequired,
  viewWalletLogsForTxn: PropTypes.instanceOf(Function).isRequired,
  updateWalletRollback: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  walletDateAt: PropTypes.string,
  formData: PropTypes.instanceOf(Object).isRequired,
  transId: PropTypes.string.isRequired,
  mobileNumber: PropTypes.instanceOf(Object).isRequired,
  onClear: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  findWallet: api.loading.indexOf(c.FIND_WALLET) > -1,
  // findingLogs: api.loading.indexOf(c.VIEW_WALLET_LOGS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(ActionItemButtonGroup);
